import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

registerCardTemplate({
    id: 'image-card2',
    name: "Image Card2",
    description: 'Display an image with a main label and sublabel. Useful for showing a visual indicator and some statistic or KPI.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-image-card2" */ "./ImageCard2")),
    icon: ['fas', 'image'],
    complexity: 'easy'
});
